(() => {
  const dataElement = document.getElementById('si-halloween-cart-data');
  if (!dataElement) return;

  let products;
  try {
    products = JSON.parse(dataElement.textContent).products || [];
  } catch (_) {
    return;
  }

  const target = 5000;
  const discountCode = 'HALLOWEEN20';
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const byVariant = new Map();
  const byHandle = new Map();
  products.forEach((product) => {
    byHandle.set(product.handle, product);
    product.variants.forEach((variant) => byVariant.set(String(variant.id), { product, variant }));
  });

  const featured = [
    'nightmare-vibes-pack',
    'halloween-essentials-mini-pack',
    'sinister-shadows-collection',
    'grim-grin-pack-semi-permanent',
    'peeking-skull-semi-permanent',
    'wicked-ghost-pair-semi-permanent',
    'wrapped-skull-semi-permanent',
    'halloween-bundle-pt-2',
    'halloween-bundle'
  ];
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
  }).format(cents / 100);

  function suggestion(product) {
    const variant = product && product.variants.find((item) => item.available);
    return variant ? { product, variant, price: Number(variant.price) } : null;
  }

  function chooseOffer(eligible, inCart) {
    const available = featured.map((handle) => suggestion(byHandle.get(handle)))
      .filter((item) => item && !inCart.has(String(item.product.id)));
    if (!available.length) return [];
    if (eligible >= target) {
      return [available.find((item) => item.price === 1399) ||
        available.find((item) => item.price === 799) || available[0]];
    }

    const gap = target - eligible;
    const single = available.filter((item) => item.price >= gap)
      .sort((a, b) => a.price - b.price)[0];
    if (single) return [single];

    let pair = null;
    for (let i = 0; i < available.length; i += 1) {
      for (let j = i + 1; j < available.length; j += 1) {
        const sum = available[i].price + available[j].price;
        if (sum >= gap && (!pair || sum < pair.sum)) {
          pair = { items: [available[i], available[j]], sum };
        }
      }
    }
    return pair ? pair.items : available.slice(0, 2);
  }

  function productTile(item) {
    const tile = document.createElement('div');
    tile.className = 'si-ho-product';
    if (item.product.image) {
      const image = document.createElement('img');
      image.src = item.product.image;
      image.alt = '';
      image.loading = 'lazy';
      tile.appendChild(image);
    }
    const label = document.createElement('span');
    label.textContent = item.product.title;
    tile.appendChild(label);
    return tile;
  }

  function createWidget(eligible, choices, signature) {
    const section = document.createElement('section');
    section.className = 'si-halloween-cart-offer';
    section.dataset.signature = signature;
    section.setAttribute('aria-label', 'Halloween cart offer');

    const eyebrow = document.createElement('div');
    eyebrow.className = 'si-ho-eyebrow';
    eyebrow.textContent = eligible < target ? 'HALLOWEEN20' : 'HALLOWEEN20 · $50 REACHED';
    section.appendChild(eyebrow);

    const message = document.createElement('p');
    message.className = 'si-ho-message';
    message.textContent = eligible < target
      ? 'Add ' + money(target - eligible) + ' in Halloween ink for 20% off'
      : 'Add a spooky extra';
    section.appendChild(message);

    if (eligible < target) {
      const track = document.createElement('div');
      track.className = 'si-ho-track';
      track.setAttribute('role', 'progressbar');
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', '50');
      track.setAttribute('aria-valuenow', String(Math.min(50, Math.round(eligible / 100))));
      track.setAttribute('aria-label', 'Halloween offer progress');
      const fill = document.createElement('span');
      fill.style.width = Math.min(100, eligible / target * 100) + '%';
      track.appendChild(fill);
      section.appendChild(track);
    }

    if (choices.length) {
      const row = document.createElement('div');
      row.className = 'si-ho-products';
      choices.forEach((item) => row.appendChild(productTile(item)));
      section.appendChild(row);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'si-ho-add';
      const cost = choices.reduce((sum, item) => sum + item.price, 0);
      button.textContent = (choices.length > 1 ? 'ADD BOTH' : 'ADD TO CART') + ' · ' + money(cost);
      button.addEventListener('click', async () => {
        button.disabled = true;
        button.textContent = 'ADDING...';
        try {
          const response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: choices.map((item) => ({ id: item.variant.id, quantity: 1 })) })
          });
          if (!response.ok) throw new Error('Cart add failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const close = document.querySelector('.hs-popup-cart-sp-load.hs-active .hs-close-popup-cart');
          const cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
          if (close && cartLink) {
            close.click();
            setTimeout(() => cartLink.click(), 100);
          }
          setTimeout(() => {
            const current = document.querySelector('.hs-popup-cart-sp-load .hs-layout-content');
            const count = current && current.querySelectorAll('.hs-sticky-cart .hs-item-cart-content').length;
            const previous = Number(section.dataset.count || '0');
            if (!count || count <= previous) {
              sessionStorage.setItem('si-reopen-halloween-cart', '1');
              window.location.reload();
            } else {
              schedule();
            }
          }, 900);
        } catch (_) {
          button.disabled = false;
          button.textContent = 'TRY AGAIN';
        }
      });
      section.appendChild(button);
    }
    return section;
  }

  function discountApplications(cart) {
    return [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap((item) => [
        ...(item.discount_allocations || []).map((entry) => entry.discount_application),
        ...(item.line_level_discount_allocations || []).map((entry) => entry.discount_application),
        ...(item.discounts || [])
      ])
    ].filter(Boolean);
  }

  let discountAttempt = '';
  let discountPending = false;
  async function ensureDiscount(signature) {
    if (discountPending || discountAttempt === signature) return;
    discountAttempt = signature;
    discountPending = true;
    try {
      const response = await fetch(cartRoot + 'cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Could not read cart');
      const cart = await response.json();
      const applications = discountApplications(cart);
      if (applications.some((item) => (item.title || '').toUpperCase() === discountCode)) return;
      // Do not replace a customer's existing code with the Halloween code.
      if (applications.some((item) => ['discount_code', 'code'].includes(item.type))) return;

      const update = await fetch(cartRoot + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: discountCode })
      });
      if (!update.ok) throw new Error('Could not apply discount');
      const updatedCart = await update.json();
      if (discountApplications(updatedCart).some((item) =>
        (item.title || '').toUpperCase() === discountCode) || updatedCart.total_price < cart.total_price) {
        sessionStorage.setItem('si-reopen-halloween-cart', '1');
        window.location.reload();
      }
    } catch (_) {
      // The Shopify code remains available at checkout if the cart request fails.
    } finally {
      discountPending = false;
    }
  }

  function update() {
    const layout = document.querySelector('.hs-popup-cart-sp-load .hs-layout-content');
    if (!layout) return;
    const cartRows = [...layout.querySelectorAll('.hs-sticky-cart .hs-item-cart-content[data-item-key]')];
    let eligible = 0;
    const inCart = new Set();
    const keys = [];
    cartRows.forEach((row) => {
      const key = (row.getAttribute('data-item-key') || '').split(':')[0];
      const quantity = Number(row.getAttribute('data-item-qty') || 1);
      keys.push(key + ':' + quantity);
      const match = byVariant.get(key);
      if (!match) return;
      eligible += Number(match.variant.price) * quantity;
      inCart.add(String(match.product.id));
    });
    const hasHalloween = eligible > 0;
    document.body.classList.toggle('si-halloween-cart', hasHalloween);
    const old = layout.querySelector('.si-halloween-cart-offer');
    if (!hasHalloween) {
      if (old) old.remove();
      return;
    }
    const signature = keys.join('|') + ':' + eligible;
    if (eligible >= target) ensureDiscount(signature);
    if (old && old.dataset.signature === signature) return;
    const choices = chooseOffer(eligible, inCart);
    const widget = createWidget(eligible, choices, signature);
    widget.dataset.count = String(cartRows.length);
    const cartList = layout.querySelector('.hs-sticky-cart');
    if (cartList) cartList.appendChild(widget);
    else layout.appendChild(widget);
    if (old) old.remove();
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; update(); }, 80);
  }

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => {
      if (mutation.target.closest && mutation.target.closest('.si-halloween-cart-offer')) return false;
      if (mutation.target.closest && mutation.target.closest('.hs-popup-cart-sp-load')) return true;
      return [...mutation.addedNodes].some((node) => node.nodeType === 1 &&
        (node.matches('.hs-popup-cart-sp-load') || node.querySelector('.hs-popup-cart-sp-load')));
    })) schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-item-qty'] });

  if (sessionStorage.getItem('si-reopen-halloween-cart')) {
    sessionStorage.removeItem('si-reopen-halloween-cart');
    setTimeout(() => {
      const cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
      if (cartLink) cartLink.click();
    }, 300);
  }
  schedule();
})();